import { createContext, useContext } from 'react';

/**
 * Studio request decorations injected onto every text-operation request
 * (Path C Slice 6, write side). The WriterLab shell provides the active
 * `studioId` + a selection-derived `metadata` block; `useTextOperationMutation`
 * reads this and merges it into each request so studio-typed metadata is
 * validated + persisted server-side — with no per-panel plumbing.
 *
 * Parallels Image Lab's StudioRequestContext (same shape, independent provider
 * so each lab decorates its own operations). Default is empty so operations run
 * unchanged outside a studio context (and in tests).
 */
export interface StudioRequestValue {
  studioId?: string;
  metadata?: Record<string, unknown>;
}

export const StudioRequestContext = createContext<StudioRequestValue>({});

export function useStudioRequest(): StudioRequestValue {
  return useContext(StudioRequestContext);
}
